// Used in pes-comparison-bar button to navigate to comparator page
export const REPLATFORMED_COMPARATOR_URL = '/v3/product-comparator';
